import type { CSSProperties, PropType } from 'vue'
import dayjs from 'dayjs'
import { defineComponent } from 'vue'
import { useMounted } from '@vueuse/core'
import { timeFromNow } from '@/utils/util'
import NewsExtraInfo from '../NewsExtraInfo'

import './style.less'

export default defineComponent({
  props: {
    hiddenFullTime: Boolean as PropType<boolean>,
    align: String as PropType<'center' | 'bottom'>,
    point: Boolean as PropType<boolean>,
    mobile: Boolean as PropType<boolean>,
    channelName: String as PropType<string>,
    time: [ String, Number ] as PropType<string | number>,
    lineStyle: Object as PropType<CSSProperties>,
    record: Object as PropType<NewsItem>,
  },
  setup(props, { attrs }) {
    const mounted = useMounted()
    const time = computed(() => {
      if (mounted.value) {
        if (props.time) {
          if ((props.hiddenFullTime) && dayjs().diff(props.time, 'day') >= 2) {
            return ''
          }
          return timeFromNow(props.time)
        }
        return ''
      }
    })

    return () => {
      return (
        <div {...attrs} class={[ 'news-details', props.point ? 'point' : '', props.mobile ? 'mobile' : '' ]}>
          {!!props.record && (
            <NewsExtraInfo
              class={props.mobile ? 'mobile-mr-16px relative' : 'mr-16px relative top-[-0.5px]'}
              type={Number(props.record?.objectType) as NewsType}
              mobile={props.mobile}
              videoInfo={props.record?.videoInfo}
              liveInfo={props.record?.liveInfo}
              photoNum={props.record?.photoNum}
            />
          )}
          {!!props.channelName && (
            <>
              <span class={'news-main-channel'}>{props.channelName}</span>
              {time.value && (
                <i class="news-details_line" style={props.lineStyle || undefined} />
              )}
            </>
          )}
          <span class={'text-hidden-1'}>{time.value}</span>
        </div>
      )
    }
  }
})
